import {Injectable} from "@angular/core";

@Injectable()
export class WindowService {

  openInNewWindow(url: string) {
    window.open(url, "_blank", "resizable=yes,noopener,noreferrer");
  }
}
